import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Brand } from "@/components/Layout";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";

const HERO = "/img/mare.jpg";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      nav("/");
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:block relative">
        <img src={HERO} alt="Terrazza sul mare" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0D2B3A]/85 via-[#0D2B3A]/30 to-transparent" />
        <div className="absolute bottom-12 left-12 right-12 text-white">
          <div className="font-serif-it text-5xl font-semibold leading-tight">Eventi sul mare,<br />contratti in ordine.</div>
          <p className="mt-4 text-white/80 max-w-md text-sm">Scheda, condizioni generali, allegati A–D e approvazione specifica ex artt. 1341-1342 c.c., con registro completo delle attività.</p>
        </div>
      </div>
      <div className="flex items-center justify-center p-6 sm:p-12">
        <form onSubmit={submit} className="w-full max-w-sm space-y-6 fade-up" data-testid="login-form">
          <Brand />
          <div>
            <h1 className="font-serif-it text-4xl font-semibold">Accesso riservato</h1>
            <p className="text-sm text-[#47606B] mt-1">Area interna per lo staff.</p>
          </div>
          <label className="block">
            <span className="text-xs font-medium text-[#47606B]">Email</span>
            <input data-testid="login-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1 w-full rounded-md border border-[#D4E6EC] bg-white px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#0B6E8F]/30" />
          </label>
          <label className="block">
            <span className="text-xs font-medium text-[#47606B]">Password</span>
            <input data-testid="login-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1 w-full rounded-md border border-[#D4E6EC] bg-white px-3 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#0B6E8F]/30" />
          </label>
          {error && <div data-testid="login-error" className="text-sm text-[#991B1B] bg-[#FEE2E2] rounded-md px-3 py-2">{error}</div>}
          <Button data-testid="login-submit-button" disabled={busy} className="w-full rounded-full h-11"><Lock size={15} className="mr-2" /> {busy ? "Accesso…" : "Entra"}</Button>
        </form>
      </div>
    </div>
  );
}
